<template>
    <div class="FundTransfer">
        <div class="heading">
            <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/icon_basic_infomation%402x.png"
                alt="">
            <div class="title">{{ $t('myAccount.text8') }}</div>
        </div>
        <div class="line_box">
            <div class="line">
                <div class="label">{{ $t('AccountAssets.text94') }}</div>
                <div class="value">
                    <el-select v-model="chuId" size="large" @change="chuChange">
                        <el-option v-for="item in list" :key="item.onlyId" :label="item.name" :value="item.onlyId"
                            :disabled="item.onlyId == ruId" />
                    </el-select>
                </div>
            </div>
            <div class="line">
                <div class="label">{{ $t('AccountAssets.text95') }}</div>
                <div class="value">
                    <el-select v-model="ruId" size="large" @change="ruChange" :placeholder="$t('withdraw.text53')">
                        <el-option v-for="item in list" :key="item.onlyId" :label="item.name" :value="item.onlyId"
                            v-show="item.fundTerminal != 3 && item.fundTerminal != 4 && item.fundTerminal != 5"
                            :disabled="item.onlyId == chuId"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="line">
                <div class="label">{{ $t('AccountAssets.text71') }}</div>
                <div class="value">
                    <el-input v-model="withdrawalAmount" size="large" :placeholder="placeholder"
                        class="withdrawal_amount" @input="specification">
                        <template #suffix>
                            <div class="fast_btn_r cursor" @click="withdrawalAmountAll">{{ $t('AccountAssets.text16') }}
                            </div>
                        </template>
                    </el-input>
                </div>
            </div>
            <div class="line">
                <div class="label">{{ $t('AccountAssets.text72') }}</div>
                <div class="value">
                    <div class="value_text">{{ amount }}</div>
                </div>
            </div>
            <el-button size="large" type="primary" class="confirm" :loading='btnLoading' :disabled="!disabled"
                @click="Confirm">{{
                    $t('withdraw.text12') }}</el-button>
        </div>
    </div>
</template>
<script>
import {
    ref,
    reactive,
    computed,
    inject,
    nextTick
} from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus'
import apiService from '@/api/request';
import { useI18n } from "vue-i18n";

export default {
    name: 'FundTransfer',
    setup() {
        const typeArr = ref([]);
        const { t } = useI18n()
        const typeId = ref('');
        const amount = ref(null);
        const limitAmount = ref(null);
        const placeholder = ref('');
        const withdrawalAmount = ref("");
        const btnLoading = ref(false);
        const disabled = computed(() => {
            return withdrawalAmount.value != ''
        })
        const chuId = ref("");
        const ruId = ref(null);

        const list = ref([])


        AccountList();

        function chuChange(item) {
            // chuItem.value = item
            console.log('item', item);
            const arr = list.value.filter(e => e.onlyId == item);
            amount.value = arr[0].amount;
            limitAmount.value = arr[0].limitAmount;
            placeholder.value = t('withdraw.text25') + '$' + limitAmount.value;
        }
        function ruChange(item) {
            // chuItem.value = item
            console.log('item', item)
        }


        //获取资金转移配置项
        function AccountList() {
            apiService.AccountList().then(res => {
                if (res.status == 1) {
                    let arr = res.data.list;
                    arr.forEach(element => {
                        element.onlyId = element.id.toString() + element.fundTerminal.toString()
                    });
                    list.value = arr
                    chuId.value = arr[0].onlyId
                    amount.value = arr[0].amount
                    limitAmount.value = arr[0].limitAmount
                    placeholder.value = t('withdraw.text25') + '$' + limitAmount.value
                }
            })
        }


        function withdrawalAmountAll() {
            withdrawalAmount.value = amount.value;
        }

        //确认
        function Confirm() {
            if (Number(withdrawalAmount.value < Number(limitAmount.value))) {
                ElMessage.error(t('fundHistory.text56') + limitAmount.value + 'USD')
                return
            }
            if (Number(withdrawalAmount.value > Number(amount.value))) {
                ElMessage.error(t('fundHistory.text57'))
                return
            }
            let chuArr = list.value.filter(e => e.onlyId == chuId.value);
            let ruArr = list.value.filter(e => e.onlyId == ruId.value);
            console.log("chuArr", chuArr)
            let param = {
                inFundTerminal: ruArr[0].fundTerminal,
                inAccountId: ruArr[0].id,
                outFundTerminal: chuArr[0].fundTerminal,
                outAccountId: chuArr[0].id,
                amount: withdrawalAmount.value
            }
            apiService.AccountTransferApply(param).then(res => {
                if (res.status == 1) {
                    ElMessage.success(t('fundHistory.text58'))
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                }
            })
            console.log(param)
        }
        //规范
        function specification(v) {
            // 输入的数据进行初始化，将非数字的替换为空
            let val = v;
            let isMatch = /^(([1-9][0-9]*)|(([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2})))$/g.test(val);
            while (!isMatch && val != '') {
                val = val.substring(0, val.length - 1)
                isMatch = /^(([1-9][0-9]*)|(([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2})))$/g.test(val);
            }
            nextTick(() => {
                withdrawalAmount.value = val;
            });
        }
        return {
            ruChange,
            chuChange,
            Confirm,
            chuChange,
            typeArr,
            typeId,
            amount,
            btnLoading,
            disabled,
            withdrawalAmount,
            limitAmount,
            placeholder,
            withdrawalAmountAll,
            specification,
            list,
            chuId,
            ruId
        }
    }
}
</script>
<style lang="less" scoped>
.FundTransfer {
    .heading {
        padding: 12px 30px;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: left;
        border-bottom: 1px solid @border-color-base;

        /*no*/
        img {
            display: block;
            width: 20px;
            height: 20px;
            margin-top: 2px;
            margin-right: 10px;
        }

        .title {
            font-weight: 500;
            width: 634px;
            text-align: left;
        }
    }

    .line_box {
        padding: 24px 30px;

        .line {
            overflow: hidden;
            margin-bottom: 16px;

            .label {
                float: left;
                height: 40px;
                line-height: 40px;
                width: 212px;
                text-align: left;
                font-size: 14px;
            }

            .value {
                float: left;
                width: 500px;
                text-align: left;
                font-size: 14px;

                .value_text {
                    line-height: 40px;
                }

                .fast_btn_r {
                    width: 64px;
                    height: 39px;
                    background: @primary-color;
                    color: white;
                    text-align: center;
                    font-size: 14px;
                    line-height: 40px;
                }
            }

            .fast {
                margin-top: 10px;
                display: flex;
                justify-content: left;

                .fast_choose {
                    width: 80px;
                    height: 32px;
                    line-height: 32px;
                    font-size: 14px;
                    border: 1px solid @border-color-base;
                    text-align: center;
                    color: @text-color-secondary;
                    margin-right: 20px;
                    cursor: pointer;
                }

                .active_choose {
                    border-color: @primary-color;
                    color: @primary-color;
                }
            }
        }

        .confirm {
            margin-top: 20px;
        }
    }
}
</style>
<style lang="less">
.FundTransfer {
    .el-select {
        width: 100%;
    }

    .el-button {
        width: 100%;
    }

    .withdrawal_amount {
        .el-input__suffix {
            right: 0;
        }
    }
}
</style>